
import { AuthLayout } from "../components/authComponents"
import styled from "styled-components"
import { COLORS } from "../constants"
import { Link, useHistory } from "react-router-dom"
import { CustomButton, Card } from "../components"
import { useState } from "react"
import { TiTick } from "react-icons/ti"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import axios from "axios"
const StyledCardContainer = styled.div`
    /* width: 100%; */
 
    display: flex;
    
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 10px;
`;
// This element is created just for the spacing in the grid
const StyledGridCardWrapper = styled.div`
    padding: 5px;
`;
const StyledCard = styled(Card)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 15px 0px;
    padding: 30px 0;
    transition: box-shadow 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);
   
`;
//DUPLICATE CONTENT.

const StyledCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.bgColor};
    width: 80px;
    height: 80px;
    border-radius: 50%;
    color:  ${props => props.color};;
`;
const colors = [
    {
        bgColor: COLORS.level_one,
        color: COLORS.level_one_text
    },
    {
        bgColor: COLORS.level_two,
        color: COLORS.level_two_text
    },
    {
        bgColor: COLORS.level_three,
        color: COLORS.level_three_text
    },
    {
        bgColor: COLORS.level_four,
        color: COLORS.level_four_text
    },
    {
        bgColor: COLORS.level_five,
        color: COLORS.level_five_text
    },
    {
        bgColor: COLORS.level_six,
        color: COLORS.level_six_text
    }
]
export default function TrialLevelsSelection() {
    const history = useHistory();
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user.user)
    const [decideLater, setDecideLater] = useState(false);
    const [trialLevels, setTrialLevels] = useState([]);
    useEffect(() => {
        axios.get(`${api}/ts/get_pt_trials/${user.email}`, {}, {
        }).then(res => {

            const result = res.data.level_trials;
            setTrialLevels(result);

        }).catch(error => {

        });

    }, [])
    return (
        <AuthLayout>
            <div className="p-4">
                <h5 className="text-center color-text-green">Explore our trial games!</h5>

                <StyledCardContainer>
                    {trialLevels.map((level, i) => {
                        return <StyledGridCardWrapper className="grid-card" key={i}>
                            <StyledCard>
                                <StyledCircle bgColor={colors[i].bgColor} color={colors[i].color}>
                                    <h1 className="mb-0">{level.level_no}</h1>
                                </StyledCircle>
                                <h4 className="mt-2">Level {level.level_no}</h4>
                                <Link to={`/test_game/${i + 1}/ref?id=1`}>
                                    <CustomButton
                                        bgColor={COLORS.green}
                                        hover={COLORS.text_green}
                                        color={COLORS.text_dark_green}
                                        disabled={level.played}
                                        style={{ padding: "0 15px", height: 40, fontSize: 13 }}
                                    >
                                        Test This Level
                                </CustomButton>
                                </Link>
                            </StyledCard>
                        </StyledGridCardWrapper>
                    })}
                    {/* {colors.map((color, i) => {
                        return <StyledGridCardWrapper className="grid-card" key={i}>
                            <StyledCard>
                                <StyledCircle bgColor={color.bgColor} color={color.color}>
                                    <h1 className="mb-0">{i + 1}</h1>
                                </StyledCircle>
                                <h4 className="mt-2">Level {i + 1}</h4>
                                <Link to={`/test_game/${i + 1}/ref?id=1`}>
                                    <CustomButton
                                        bgColor={COLORS.green}
                                        hover={COLORS.text_green}
                                        color={COLORS.text_dark_green}
                                        style={{ padding: "0 15px", height: 40, fontSize: 13 }}
                                    >
                                        Test This Level
                                                    </CustomButton>
                                </Link>
                            </StyledCard>
                        </StyledGridCardWrapper>
                    })} */}
                </StyledCardContainer>
                <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                        <div className="circle-sm" style={{ background: COLORS.green, cursor: "pointer" }} onClick={() => setDecideLater(!decideLater)}>
                            {decideLater && <TiTick size={40} color={COLORS.text_dark_green} />}
                        </div>
                        <div className="ml-1">No, thanks</div>
                    </div>
                    <CustomButton
                        bgColor={COLORS.orange}
                        hover={COLORS.orange_hover}
                        color={COLORS.dark_orange}
                        disabled={!decideLater}
                        className="next"
                        onClick={() => history.replace('/dashboard')}
                        style={{ padding: "0 30px", height: 50, fontSize: 16, marginTop: 10 }}
                    >
                        Launch App!
                    </CustomButton>
                </div>
            </div >
        </AuthLayout >
    )
}
